import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styles from './law_firm_description.module.scss';

type Props = {
  hasExperience: boolean;
  pageName: string;
  decisionCount: number;
};

export const LawFirmDescription: FC<Props> = ({
  decisionCount,
  pageName,
  hasExperience,
}) => {
  const doctrine = (
    <b>
      <FormattedMessage id="law-firm/page/description/LawFirmDescription.tsx/2" />
    </b>
  );
  const name = <b>{pageName}</b>;
  const nameEnd = <b>{`${pageName}.`}</b>;
  return (
    <>
      {decisionCount ? (
        <>
          <hr className={styles.separator} />
          <div className={styles.block}>
            <span className={styles.title}>
              <FormattedMessage id="law-firm/page/description/LawFirmDescription.tsx/1" />
            </span>
          </div>
          <div className={styles.item}>
            <FormattedMessage
              id="law-firm/page/description/LawFirmDescription.tsx/3"
              values={{
                doctrine,
                end: hasExperience ? (
                  <FormattedMessage
                    id="law-firm/page/description/LawFirmDescription.tsx/5"
                    values={{ name }}
                  />
                ) : (
                  nameEnd
                ),
              }}
            />
          </div>
        </>
      ) : (
        <span className={styles.item}>
          <FormattedMessage
            id="law-firm/page/description/LawFirmDescription.tsx/4"
            values={{ doctrine, name: nameEnd }}
          />
        </span>
      )}
    </>
  );
};
